import React from "react";

import Header from "../src/components/Header/Header";

import ContatoBox from "../src/components/ContatoBox/ContatoBox";
import Title from "../src/components/Title/Title";
import Email from "../src/assets/contato/email.svg";

import Manutencao from "../src/components/Helper/Manutencao/Manutencao";

import Footer from "../src/components/Footer/Footer";
import Head from "next/head";
import Image from "next/future/image";

const Contato = () => {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Salinas, salinas, salinas embalagem, cartonagem, embalagem, cartonagem salinas, empresa Salinas, embalagem personalizada, embalagem papelao, salinas pederneiras, salinas sp"
        />
        <meta httpEquiv="Cache-Control" content="max-age=604800" />
        <meta name="description" content="Salinas embalagem" />
        <meta name="title" content="Contato | Cartonagem Salinas" />
        <title>Contato | Cartonagem Salinas</title>
        <meta name="copyright" content="© 2022 Salinas Embalagem" />
      </Head>
      <Header />
      <main style={{ marginBottom: "40px" }}>
        <Title title="Contato">
          <Image src={Email} alt="email" />
        </Title>
        <ContatoBox noBg={true} />

        {/* <Manutencao /> */}
      </main>
      <Footer />
    </>
  );
};

export default Contato;
